<elder-basic-pane-layout class="full">
  @if (workOrderId$ | async; as workOrderId) {
    <elder-pane>
      <elder-pane-header>
        <elder-pane-title>
          {{ 'orders.work.order' | translate }} {{ workOrderId }}
        </elder-pane-title>
      </elder-pane-header>
      <elder-pane-content>
        @if (isTerminalPackageUiEnabled()) {
          <mat-tab-group
            class="flex"
            animationDuration="0ms"
            elderTabGroupRouting="terminalOrderBatchesTab"
          >
            <!-- Tab Overview -->
            <mat-tab label="{{ 'workBatches.title' | translate }}" elderTab="workBatches">
              <ng-template [ngTemplateOutlet]="batches"></ng-template>
            </mat-tab>
            <mat-tab label="{{ 'packages.packages' | translate }}" elderTab="packages">
              @if (workCenterId$ | async; as workCenterId) {
                <app-terminal-order-packages
                  [workOrderId]="workOrderId"
                  [workCenterId]="workCenterId"
                ></app-terminal-order-packages>
              }
            </mat-tab>
          </mat-tab-group>
        } @else {
          <div class="flex">
            <ng-template [ngTemplateOutlet]="batches"></ng-template>
          </div>
        }
      </elder-pane-content>
    </elder-pane>
  }
</elder-basic-pane-layout>

<ng-template #batches>
  @if (workStationId$ | async; as workStationId) {
    @if (workCenterId$ | async; as workCenterId) {
      <app-terminal-work-batches-table
        [data]="data"
        [workStationId]="workStationId"
        [workCenterId]="workCenterId"
      ></app-terminal-work-batches-table>
    }
  }
</ng-template>
